import type { ReactNode } from "react";
import MicroLabel from "@/components/base/MicroLabel";
import type { MicroMark } from "@/components/base/MicroLabel";

type Tone = "neutral" | "accent" | "primary";

const BOX: Record<Tone, string> = {
  neutral: "border-2 border-foreground-950 bg-background-50",
  accent: "border-2 border-foreground-950 bg-accent-100",
  primary: "border-2 border-foreground-950 bg-primary-100",
};

const BODY: Record<Tone, string> = {
  neutral: "text-foreground-800",
  accent: "text-accent-900",
  primary: "text-foreground-800",
};

interface CalloutProps {
  label: string;
  mark: MicroMark;
  tone?: Tone;
  className?: string;
  children: ReactNode;
}

/**
 * Thick-bordered label panel — the "Do this instead" / "What actually happens"
 * family. Border weight, padding and label position are fixed here.
 */
export default function Callout({
  label,
  mark,
  tone = "neutral",
  className = "",
  children,
}: CalloutProps) {
  return (
    <div className={`${BOX[tone]} px-5 py-4 ${className}`}>
      <MicroLabel mark={mark}>{label}</MicroLabel>
      <p className={`mt-2 text-sm leading-relaxed ${BODY[tone]}`}>{children}</p>
    </div>
  );
}